import { render } from "./ImportInstruction.vue?vue&type=template&id=8f92a59a&scoped=true"
import script from "./ImportInstruction.vue?vue&type=script&lang=js"
export * from "./ImportInstruction.vue?vue&type=script&lang=js"

import "./ImportInstruction.vue?vue&type=style&index=0&id=8f92a59a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f92a59a"]])

export default __exports__